module.exports = __webpack_public_path__ + "static/media/25UNHCR4.ff9b845d.jpg";